import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
    const [site, setSite] = useState(null);
    const [failed, setFailed] = useState(false);
    const [lang, setLang] = useState(() => localStorage.getItem("btf-lang") || "en");

    const load = useCallback(() => {
        return api.get("/site").then((r) => { setSite(r.data); setFailed(false); }).catch(() => setFailed(true));
    }, []);

    useEffect(() => { load(); }, [load]);
    useEffect(() => { localStorage.setItem("btf-lang", lang); }, [lang]);

    const tx = useCallback((field) => {
        if (field == null) return "";
        if (typeof field === "string") return field;
        return field[lang] ?? field.en ?? "";
    }, [lang]);

    useEffect(() => {
        if (!site?.settings) return;
        const s = site.settings;
        document.title = tx(s.seo_title) || "Beyond The Field+";
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", tx(s.seo_description) || "");
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute("content", tx(s.seo_title) || "");
        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute("content", tx(s.seo_description) || "");
    }, [site, lang, tx]);

    return (
        <SiteCtx.Provider value={{ site, lang, setLang, tx, reload: load, failed }}>
            {children}
        </SiteCtx.Provider>
    );
}

export const useSite = () => useContext(SiteCtx);
